import { createRouter, createWebHistory } from 'vue-router';
import Index from '../pages/Index.vue';
import MarketView from '../pages/MarketView.vue';

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/market-view/:id/:selectedChoice?',
    name: 'MarketView',
    component: MarketView,
    props: true
  }
  // Add more routes here as needed
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;